import { render } from "./InventoryPlanProducts.vue?vue&type=template&id=36b95de5"
import script from "./InventoryPlanProducts.vue?vue&type=script&lang=js"
export * from "./InventoryPlanProducts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__